<header>
  <h1>Homepage Offers</h1>
</header>
<section class="audit-log">
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    <ng-container cdkDropListGroup>
      @for (pair of homepageOfferPairs; track pair) {
        <div class="category-pair">
          <div class="category-column">
            <div class="panel-wrapper">
              <ng-container
                *ngTemplateOutlet="categoryPanel; context: { category: pair.current }"
              ></ng-container>
            </div>
          </div>
          <div class="category-column">
            <div class="panel-wrapper">
              <ng-container
                *ngTemplateOutlet="categoryPanel; context: { category: pair.future }"
              ></ng-container>
            </div>
          </div>
        </div>
      }
      <ng-template #categoryPanel let-category="category">
        @if (category.title) {
          <div class="panel">
            <mat-expansion-panel [expanded]="true" class="expansion">
              <mat-expansion-panel-header>
                <mat-panel-title>{{ category.title }}</mat-panel-title>
                <mat-panel-description>
                  <button
                    (click)="addCarouselItem($event, category.id, category.title)"
                    mat-button
                    matTooltip="Add carousel item"
                    type="button"
                    >
                    <mat-icon>add</mat-icon>
                    Add carousel item
                  </button>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div
                cdkDropList
                (cdkDropListDropped)="drop($event, category.id)"
                [cdkDropListData]="category.items"
                class="homepage-list"
                >
                @for (listing of category.items; track listing) {
                  <div
                    cdkDrag
                    class="homepage-item"
                    >
                    <div class="item-container">
                      {{ listing.title }}
                      @if (!listing.carousel_image_id) {
                        <button
                          (click)="addImage($event, listing)"
                          mat-button
                          matTooltip="Add carousel item"
                          type="button"
                          >
                          <mat-icon>add</mat-icon>
                          Add image
                        </button>
                      }
                      @if (listing.carousel_image_id) {
                        <button
                          (click)="removeImage(listing)"
                          mat-button
                          matTooltip="Remove carousel image"
                          type="button"
                          >
                          <mat-icon>delete</mat-icon>
                          Remove image
                        </button>
                      }
                      <button
                        (click)="deleteListing(listing.carousel_id)"
                        mat-icon-button
                        matTooltip="Delete listing from carousel"
                        >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                    @if (category.title.includes('Future')) {
                      <div
                        class="info-container"
                        >
                        <div>
                          Replacing: <b>{{ listing.listing_to_replace_title }}</b>
                        </div>
                        <div>Start Date: <b>{{ listing.listing_start_date }}</b></div>
                      </div>
                    }
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </div>
        }
      </ng-template>
    </ng-container>
  }
</section>
